import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { LanguageAbbreviation } from '@/constants/common';
import { createTranslationTable, flattenObject } from './until';
import translation_zh from './zh';
import translation_vi from './vi';

// Only Simplified Chinese and Vietnamese are exposed as UI languages for now.
// Vietnamese UI strings are provided in `vi`, missing keys will fall back to zh.
const resources = {
  [LanguageAbbreviation.Zh]: translation_zh,
  [LanguageAbbreviation.Vi]: translation_vi,
};

const supportedLngs = [LanguageAbbreviation.Zh, LanguageAbbreviation.Vi];

const zhFlattened = flattenObject(translation_zh);
const viFlattened = flattenObject(translation_vi);

export const translationTable = createTranslationTable(
  [zhFlattened, viFlattened],
  ['zh', 'vi'],
);

// 初始化时优先从 localStorage 中读取语言，没有则使用 zh
const savedLng =
  typeof window !== 'undefined'
    ? localStorage.getItem('lng') || LanguageAbbreviation.Zh
    : LanguageAbbreviation.Zh;

i18n.use(initReactI18next).init({
  lng: savedLng,
  supportedLngs,
  resources,
  fallbackLng: LanguageAbbreviation.Zh,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
